var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-actions',[_c('button',{on:{"click":_vm.syncDealers}},[_vm._v("Синхронизировать")]),_c('router-link',{attrs:{"to":"/dealers/new","tag":"button"}},[_vm._v("Создать")])],1),_c('table-element',_vm._b({on:{"changeOrder":_vm.changeOrder,"rowClick":_vm.rowClick},scopedSlots:_vm._u([{key:"city",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value.title))]}},{key:"status",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value.title))]}},{key:"phones",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value ? value.join(',') : ''))]}},{key:"address",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value ? value.join(',') : ''))]}}])},'table-element',_vm.tableOpt,false)),_c('paginator',{attrs:{"model":_vm.meta.list_data},on:{"change":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }